import React, { useCallback, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useParams } from 'react-router-dom';
import { EquipmentAssignList, EquipmentInfo, EquipmentAssignCreate } from 'src/request/Equipment';
import useLoading from 'src/utils/useLoading';
import { CButton, CSelect, CPagination } from '@coreui/react';
import useCustomPagination from 'src/utils/useCustomPagination';
import { debounce } from 'lodash';
const Swal = require('sweetalert2');
const EquipmentRow = ({ item, index, selected, onModelChange, onDateChange, onSelectChange, getEquipmentKey, equipmentSelections, view = 'table' }) => {
  const key = getEquipmentKey(item);
  const selectionData = equipmentSelections[key] || {};
  const isReady = selectionData.selectedEquipmentId && selectionData.dateStart && selectionData.dateEnd;

  const isDateUnavailable = (date) => {
    if (!selectionData.unavailableDates || selectionData.unavailableDates.length === 0) return false;

    const checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);

    return selectionData.unavailableDates.some(range => {
      const startDate = new Date(range.date_start);
      const endDate = new Date(range.date_end);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return checkDate >= startDate && checkDate <= endDate;
    });
  };

  if (view === 'card') {
    return (
      <div className={`p-2 bg-white rounded-lg shadow transition ${selected ? 'ring-2 ring-blue-500 bg-blue-50' : ''}`}>
        <div className="space-y-3">
          <div>
            <label className="block mb-1 text-xs font-medium text-gray-500 uppercase">
              Equipment Name
            </label>
            <p className="text-sm font-medium text-gray-900">{item.equipmentName}</p>
          </div>

          <div>
            <label className="block mb-1 text-xs font-medium text-gray-500 uppercase">
              Model
            </label>
            <CSelect
              size="sm"
              value={selectionData.selectedEquipmentId || ''}
              onChange={(e) => onModelChange(index, e)}
              className="w-full px-3 py-1 text-sm rounded-md"
            >
              <option value="">Select model</option>
              {item.equipmentDetails.map((equip) => (
                <option key={equip.equipment_id} value={equip.equipment_id}>
                  {equip.label}
                </option>
              ))}
            </CSelect>
          </div>

          <div>
            <label className="block mb-1 text-xs font-medium text-gray-500 uppercase">
              Location
            </label>
            <p className="text-sm text-gray-700">{selectionData.location || item.location}</p>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block mb-1 text-xs font-medium text-gray-500 uppercase">
                Date Start
              </label>
              <DatePicker
                selected={selectionData?.dateStart}
                onChange={(date) => onDateChange(index, 'dateStart', date)}
                dateFormat="yyyy-MM-dd"
                placeholderText="Select date"
                filterDate={(date) => !isDateUnavailable(date)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                disabled={!selectionData?.selectedEquipmentId}
              />
            </div>

            <div>
              <label className="block mb-1 text-xs font-medium text-gray-500 uppercase">
                Date End
              </label>
              <DatePicker
                selected={selectionData?.dateEnd}
                onChange={(date) => onDateChange(index, 'dateEnd', date)}
                dateFormat="yyyy-MM-dd"
                placeholderText="Select date"
                minDate={selectionData?.dateStart}
                filterDate={(date) => !isDateUnavailable(date)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                disabled={!selectionData?.dateStart}
              />
            </div>
          </div>

          <div className="flex items-center justify-between pt-2 border-t">
            <span className="text-xs font-medium text-gray-500 uppercase">
              Select for Request
            </span>
            <input
              type="checkbox"
              checked={selected || false}
              onChange={() => onSelectChange(index)}
              disabled={!isReady}
              className={`w-5 h-5 rounded border-gray-300 focus:ring-2 focus:ring-blue-500 ${!isReady ? 'cursor-not-allowed opacity-50' : 'text-blue-600 cursor-pointer'
                }`}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <tr className={`transition hover:bg-gray-50 border-b ${selected ? 'bg-blue-50' : ''}`}>
      <td className="p-3 text-gray-700">{item.equipmentName}</td>

      <td className="p-3">
        <CSelect
          size='sm'
          value={selectionData.selectedEquipmentId || ''}
          onChange={(e) => onModelChange(index, e)}
          className="w-full px-2 py-1 text-sm rounded-md min-w-[150px]"
        >
          <option value="">Select model</option>
          {item.equipmentDetails.map((equip) => (
            <option key={equip.equipment_id} value={equip.equipment_id}>
              {equip?.label}
            </option>
          ))}
        </CSelect>
      </td>

      <td className="p-3 text-gray-700">{selectionData?.location || item?.location}</td>

      <td className="p-3">
        <DatePicker
          selected={selectionData?.dateStart}
          onChange={(date) => onDateChange(index, 'dateStart', date)}
          dateFormat="yyyy-MM-dd"
          placeholderText="Select date"
          filterDate={(date) => !isDateUnavailable(date)}
          className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md min-w-[150px]"
          disabled={!selectionData?.selectedEquipmentId}
        />
      </td>

      <td className="p-3">
        <DatePicker
          selected={selectionData?.dateEnd}
          onChange={(date) => onDateChange(index, 'dateEnd', date)}
          dateFormat="yyyy-MM-dd"
          placeholderText="Select date"
          minDate={selectionData?.dateStart}
          filterDate={(date) => !isDateUnavailable(date)}
          className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md min-w-[150px]"
          disabled={!selectionData?.dateStart}
        />
      </td>

      <td className="p-3 text-center">
        <input
          type="checkbox"
          checked={selected || false}
          onChange={() => onSelectChange(index)}
          disabled={!isReady}
          className={`w-4 h-4 rounded border-gray-300 focus:ring-2 focus:ring-blue-500 ${!isReady ? 'cursor-not-allowed opacity-50' : 'text-blue-600 cursor-pointer'
            }`}
        />
      </td>
    </tr>
  );
};

const EquipmentAssign = ({onRefreshHistory}) => {
  const { id: projectID } = useParams();
  const [equipmentList, setEquipmentList] = useState([]);
  const [selectedEquipment, setSelectedEquipment] = useState({});
  const [equipmentSelections, setEquipmentSelections] = useState({});
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { SmallLoading } = useLoading();
  const { currentPage, pageSize, totalPages, updatePagination } = useCustomPagination();
  const company_id = parseInt(localStorage.getItem('company_id'));
  const getEquipmentKey = (item) => `${item.peId}-${item.categoryId}-${item.psowId}`;
  let user_id = parseInt(localStorage.getItem('user_id'));

  const fetchList = async () => {
    try {
      setLoading(true);
      const response = await EquipmentAssignList({ projectId: projectID, page: currentPage, per_page: pageSize });
      if (!response.status === 200) return;

      let totalPages_ = Math.max(response.data.total_pages ?? 0, 1);
      if (totalPages !== totalPages_) {
        updatePagination({ newTotalPages: totalPages_ });
      }

      const flattened = [];
      response?.data?.data?.forEach((equipment) => {
        equipment.details.forEach((detail) => {
          flattened.push({
            equipmentName: equipment.equipmentName,
            categoryId: detail.category_id,
            peId: detail.pe_id,
            psowId: detail.psow_id,
            rental: detail.rental,
            request: detail.request,
            request_count: detail.request_count,
            sowId: detail.sow_id,
            workItemId: detail.work_item_id,
            location: detail.location || 'N/A',
            equipmentDetails: detail.equipment_details,
          });
        });
      });

      setEquipmentList(flattened);
      setSelectedEquipment({});
    } catch (err) {
      console.error('Something went wrong', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList();
  }, [projectID, currentPage]);

  const updateEquipment = (key, updatedData) => {
    setEquipmentSelections((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        ...updatedData,
      }
    }));
  };

  const handleModelChange = async (index, event) => {
    const equipmentId = event.target.value;
    const item = equipmentList[index];
    const key = getEquipmentKey(item);

    if (!equipmentId) {
      setEquipmentSelections((prev) => {
        const updated = { ...prev };
        delete updated[key];
        return updated;
      });

      setSelectedEquipment((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
      return;
    }

    const equipment = item.equipmentDetails.find((e) => e.equipment_id === parseInt(equipmentId));

    try {
      const response = await EquipmentInfo({ projectID: projectID, equipmentID: parseInt(equipmentId) });
      const equipmentInfo = response?.data?.response || {};

      const updatedData = {
        selectedEquipmentId: Number(equipmentId),
        selectedModel: equipment?.label,
        peId: item.peId,
        categoryId: item.categoryId,
        psowId: item.psowId,
        sowId: item.sowId,
        workItemId: item.workItemId,
        equipmentName: item.equipmentName,
        brand: equipmentInfo.brand,
        brandId: equipmentInfo.brand_id,
        rental: equipmentInfo.rental,
        location: equipmentInfo.location || item.location || 'N/A',
        unavailableDates: equipmentInfo.unavailable_date || [],
        dateStart: null,
        dateEnd: null,
        selected: false
      };

      updateEquipment(key, updatedData);
    } catch (error) {
      console.error('Error fetching equipment info:', error);
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'Something went wrong while fetching your model details. Please contact support.',
      })
    }
  };

  const handleDateChange = (index, field, date) => {
    const item = equipmentList[index];
    const key = getEquipmentKey(item);

    updateEquipment(key, { [field]: date });
  };

  const handleCheckboxChange = (index) => {
    const item = equipmentList[index];
    const key = getEquipmentKey(item);
    const currentlySelected = selectedEquipment[index];

    setSelectedEquipment((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));

    setEquipmentSelections((prev) => ({
      ...prev,
      [key]: { ...prev[key], selected: !currentlySelected }
    }));
  };

  const handleReset = () => {
    setSelectedEquipment({});
    setEquipmentSelections({});
    fetchList();
  };

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const handleSubmitRequest = async () => {
    const selectedItems = Object.entries(equipmentSelections)
      .filter(([_, item]) => item.selected)
      .map(([_, item]) => item);
 
    const requestPayload = selectedItems.map((item) => ({
      brand: item.selectedModel || 'N/A',
      brand_id: parseInt(item.brandId),
      category: item.equipmentName,
      category_id: item.categoryId,
      date_end: formatDate(item.dateEnd),
      date_start: formatDate(item.dateStart),
      equipment_id: parseInt(item.selectedEquipmentId),
      rental: 0,
      psow_id: item.psowId,
      pe_id: item.peId
    }));
 
    const payload = {
      project_id: parseInt(projectID),
      company_id: company_id,
      user_id: user_id,
      type: 'Equipment',
      request: requestPayload
    };
    try {
      setIsSubmitting(true);
      const response = await EquipmentAssignCreate(payload);
 
      if (response?.data?.status === 200 || response?.status === 200) {
        Swal.fire({
          title: 'Success',
          icon: 'success',
          text: 'Successfully assigned equipment',
        })
        onRefreshHistory();
        handleReset();
      } else {
        Swal.fire({
          title: 'Oops',
          icon: 'error',
          text: 'Something went wrong. Please try again',
        })
      }
    } catch (error) {
      console.error('Something went wrong. Please try again', error);
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'Something went wrong. Please try again',
      })
    } finally {
      setIsSubmitting(false);
    }
  };

  const debounceSetCurrentPage = useCallback(
    debounce((page) => {
      if (page > 0) updatePagination({ newCurrentPage: page });
    }, 400),
    [],
  );

  const hasAnySelection = Object.values(equipmentSelections).some(item => item.selected);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <SmallLoading />
      </div>
    );
  }

  return (
    <div className="w-full p-2 sm:p-6">
      {equipmentList.length > 0 && (
        <div className="flex flex-col gap-3 pb-4 mt-2 sm:flex-row sm:justify-end">
          <CButton
            size="sm"
            onClick={handleReset}
            className="w-full text-sm text-gray-600 transition border border-gray-300 rounded-lg hover:bg-gray-100 sm:w-auto"
          >
            Reset
          </CButton>
          <CButton
            onClick={handleSubmitRequest}
            size="sm"
            disabled={!hasAnySelection || isSubmitting}
            className={`w-full sm:w-auto rounded-lg text-white text-sm font-medium transition bg-aimhi-primary ${(!hasAnySelection || isSubmitting) ? 'cursor-not-allowed opacity-70' : ''}`}
          >
            {isSubmitting ? 'Creating...' : 'Create Request'}
          </CButton>
        </div>
      )}

      {equipmentList.length === 0 ? (
        <div className="p-6 text-center">
          No equipment available
        </div>
      ) : (
        <>
          <div className="block space-y-4 lg:hidden">
            {equipmentList.map((item, index) => (
              <>
                <EquipmentRow
                  key={index}
                  item={item}
                  index={index}
                  selected={selectedEquipment[index]}
                  onModelChange={handleModelChange}
                  onDateChange={handleDateChange}
                  onSelectChange={handleCheckboxChange}
                  getEquipmentKey={getEquipmentKey}
                  equipmentSelections={equipmentSelections}
                  view="card"
                />
                <CPagination activePage={currentPage} onActivePageChange={debounceSetCurrentPage} pages={totalPages} doubleArrows={true} align="center" className="mt-4" />
              </>
            ))}
          </div>

          <div className="hidden overflow-x-auto lg:block">
            <table className="w-full text-sm text-left border">
              <thead>
                <tr className="text-xs font-semibold text-gray-700 uppercase border-b bg-gray-50">
                  <th className="p-3">Equipment Name</th>
                  <th className="p-3">Model</th>
                  <th className="p-3">Location</th>
                  <th className="p-3">Date Start</th>
                  <th className="p-3">Date End</th>
                  <th className="p-3 text-center">Select</th>
                </tr>
              </thead>
              <tbody>
                {equipmentList.map((item, index) => (
                  <EquipmentRow
                    key={index}
                    item={item}
                    index={index}
                    selected={selectedEquipment[index]}
                    onModelChange={handleModelChange}
                    onDateChange={handleDateChange}
                    onSelectChange={handleCheckboxChange}
                    getEquipmentKey={getEquipmentKey}
                    equipmentSelections={equipmentSelections}
                    view="table"
                  />
                ))}
              </tbody>
            </table>
            <CPagination activePage={currentPage} onActivePageChange={debounceSetCurrentPage} pages={totalPages} doubleArrows={true} align="center" className="mt-4" />
          </div>
        </>
      )}
    </div>
  );
};

export default EquipmentAssign;
